import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountingHeroComponent } from '../../Components/Accounting/accounting-hero/accounting-hero';
import { AccountingOverviewComponent } from '../../Components/Accounting/accounting-overview/accounting-overview';
import { AccountingFeaturesComponent } from '../../Components/Accounting/accounting-features/accounting-features';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-accounting-page',
  standalone: true,
  imports: [CommonModule, AccountingHeroComponent, AccountingOverviewComponent, AccountingFeaturesComponent],
  templateUrl: './accounting-page.html',
  styleUrls: ['./accounting-page.css'],
})
export class AccountingPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Accounting Software',
      description:
        'Ledgers, journal entries, chart of accounts, tax codes, and financial reports — orderYaa Accounting keeps your books accurate and always up to date.',
      path: '/accounting',
    });
  }
}
